import { Checkbox } from '@vkontakte/vkui';
import { ModalPageHeader } from '@vkontakte/vkui';
import { ResizableModalPage } from '../../ui/ResizableModalPage';
import { DragHandle } from '../../ui/DragHandle';
import type { Guest, SeatingTable } from '../../types';

interface AutoSeatPreviewProps {
  openToken: number;
  plan: Map<string, string[]>;
  unplaced: string[];
  tables: SeatingTable[];
  guestsById: Map<string, Guest>;
  skipHeadTable: boolean;
  onToggleSkipHead: (v: boolean) => void;
  onApply: () => void;
  onClose: () => void;
  saving: boolean;
}

export default function AutoSeatPreview({
  openToken,
  plan,
  unplaced,
  tables,
  guestsById,
  skipHeadTable,
  onToggleSkipHead,
  onApply,
  onClose,
  saving,
}: AutoSeatPreviewProps) {
  const name = (id: string) => {
    const g = guestsById.get(id);
    return g ? `${g.first_name} ${g.last_name || ''}`.trim() : id;
  };

  const plannedTables = tables.filter((t) => (plan.get(t.id) || []).length > 0);

  return (
    <ResizableModalPage openToken={openToken} id="auto-seat" onClose={onClose} settlingHeight={80}>
      <ModalPageHeader>Автоматическая рассадка</ModalPageHeader>
      <DragHandle />
      <div className="st-root">
        <div style={{ padding: '4px 16px 16px' }}>
          {plannedTables.map((t) => (
            <div key={t.id} className="st-card" style={{ marginBottom: 10 }}>
              <div className="st-card__name" style={{ fontSize: 19 }}>
                {t.name}
              </div>
              <div className="st-card__meta">
                +{(plan.get(t.id) || []).length} · всего будет {t.seats}
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 10 }}>
                {(plan.get(t.id) || []).map((id) => (
                  <span key={id} className="st-new">
                    {name(id)}
                  </span>
                ))}
              </div>
            </div>
          ))}

          {unplaced.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <div className="st-card__meta">Не поместились: {unplaced.length}</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
                {unplaced.map((id) => (
                  <span key={id} className="st-new st-new--unplaced">
                    {name(id)}
                  </span>
                ))}
              </div>
            </div>
          )}

          <div style={{ marginTop: 16 }}>
            <Checkbox checked={skipHeadTable} onChange={(e) => onToggleSkipHead(e.currentTarget.checked)}>
              Не трогать главный стол
            </Checkbox>
          </div>

          <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
            <button type="button" className="st-btn-primary" disabled={saving || plannedTables.length === 0} onClick={onApply}>
              {saving ? '…' : 'Применить'}
            </button>
            <button type="button" className="st-btn-secondary" onClick={onClose}>
              Отмена
            </button>
          </div>
        </div>
      </div>
    </ResizableModalPage>
  );
}
